// Pre-project locations (see the tender API's PreProjectLocationDto): a
// pre-project applies to one or more places, each a CITY, a whole REGION or a
// whole PROVINCE. A REGION or PROVINCE entry may carry a `customName` — a
// free-text place the catalog does not know (e.g. a military base) — which is
// displayed exactly like a city name.

export const LOCATION_LEVEL = Object.freeze({
  CITY: 'CITY',
  REGION: 'REGION',
  PROVINCE: 'PROVINCE',
});

// What a location entry is shown as: the custom place name, else the catalog name.
export const locationDisplayName = (location) => {
  if (!location) return null;
  return location.customName || location.name || null;
};

// The locations of a pre-project as the API lists them. Older payloads carried a
// single flat cityName/regionName — rebuild one CITY entry from them so the
// display stays uniform.
export const locationsOf = (preProject) => {
  if (!preProject) return [];
  if (Array.isArray(preProject.locations)) return preProject.locations;
  if (preProject.cityName || preProject.regionName) {
    return [
      {
        level: preProject.cityName ? LOCATION_LEVEL.CITY : LOCATION_LEVEL.REGION,
        locationId: preProject.cityId || preProject.regionId || null,
        name: preProject.cityName || preProject.regionName,
        customName: null,
        regionName: preProject.regionName || null,
        provinceName: preProject.provinceName || null,
      },
    ];
  }
  return [];
};

// Two entries are the same place when they point at the same catalog row at
// the same level (a custom place is distinct from the whole region/province).
export const isSameLocation = (a, b) =>
  !!a &&
  !!b &&
  a.level === b.level &&
  a.locationId === b.locationId &&
  (a.customName || null) === (b.customName || null);

// The payload form of a location (what the create/update request expects).
export const toLocationPayload = (location) => ({
  level: location.level,
  locationId: location.locationId,
  customName: location.customName || null,
});
